import { render, staticRenderFns } from "./GameScore.vue?vue&type=template&id=0014100b&scoped=true&"
import script from "./GameScore.vue?vue&type=script&lang=js&"
export * from "./GameScore.vue?vue&type=script&lang=js&"
import style0 from "./GameScore.vue?vue&type=style&index=0&id=0014100b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0014100b",
  null
  
)

export default component.exports